module.exports = __webpack_public_path__ + "img/07-oval-convex-1-2-3-base.cf515832.svg";